<template>
    <div @click.stop="close"
         class="fixed inset-0 w-screen h-screen z-50"
         style="background: #00000088"
    >
        <div @click.stop="ignore"
             class="bg-white"
             id="content_container"
        >
            <div class="absolute w-full h-full pt-12">
                <div class="relative w-full h-full overflow-y-scroll" id="detailProject">

                    <div class="w-full relative" id="main_image">
                        <img alt=""
                             class="w-full h-full object-cover"
                             ref="mainImage"
                        >
                        <transition name="opacity">
                            <div class="absolute bg-white inset-0 flex justify-center items-center"
                                 v-if="!mainImageLoaded"
                            >
                            </div>
                        </transition>
                    </div>

                    <div class="w-11/12 my-6 mx-auto">
                        <h1 class="uppercase text-4xl text-heading font-bold">
                            {{ title }}
                        </h1>
                        <p class="uppercase font-extrabold text-sm text-blue-400">
                            {{ subTitle }}
                        </p>

                        <div class="flex flex-col md:flex-row justify-between my-8">
                            <div class="flex justify-start items-start w-full md:w-1/3">
                                <img alt="" class="w-8 tablet:w-1/12 xl:w-8" src="../assets/img/icons/globe_icon.png">
                                <div class="pl-2">
                                    <p class="text-heading font-extrabold">
                                        {{ tr('references.country') }}
                                    </p>
                                    <p class="text-text">
                                        {{ country }}
                                    </p>
                                </div>
                            </div>
                            <div class="flex justify-start md:justify-center items-start w-full md:w-1/3 my-5 md:my-0">
                                <img alt="" class="w-8 tablet:w-1/12 xl:w-8"
                                     src="../assets/img/icons/location_icon.png"
                                >
                                <div class="pl-2">
                                    <p class="text-heading font-extrabold">
                                        {{ tr('references.location') }}
                                    </p>
                                    <p class="text-text">
                                        {{ location }}
                                    </p>
                                </div>
                            </div>
                            <div class="flex justify-start md:justify-end items-start w-full md:w-1/3">
                                <img alt="" class="w-8 tablet:w-1/12 xl:w-8" src="../assets/img/icons/been_icon.png">
                                <div class="pl-2">
                                    <p class="text-heading font-extrabold">
                                        {{ tr('references.completion') }}
                                    </p>
                                    <p class="text-text">
                                        {{ completion }}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="text-justify pr-1">
                            <h1 class="font-normal text-heading text-sm md:text-base text-gray-900 mb-2 md:mb-1"
                                v-html="textHeader"
                            >
                            </h1>
                            <p class="pt-2 text-text text-sm md:text-base md:pt-5"
                               v-html="text"
                            >
                            </p>
                        </div>

                        <div class="flex flex-col md:flex-row md:flex-wrap justify-between my-4 md:mt-8 md:mb-10">
                            <div class="w-full md:w-1/3 my-4 md:my-2 flex flex-col justify-start items-start">
                                <div class="font-extrabold text-heading text-xl">
                                    {{ tr('references.investor') }}
                                </div>
                                <div class="text-xl text-text">
                                    {{ investor }}
                                </div>
                            </div>

                            <div
                                class="w-full md:w-1/3 my-4 md:my-2 flex flex-col justify-start items-start md:items-center">
                                <div class="font-extrabold text-heading text-xl">
                                    {{ tr('references.architect') }}
                                </div>
                                <div class="text-xl text-text"
                                     v-for="architect in architect"
                                >
                                    {{ architect }}
                                </div>
                            </div>

                            <div
                                class="w-full md:w-1/3 my-4 md:my-2 flex flex-col justify-start items-start md:items-end">
                                <template v-if="author">
                                    <div class="font-extrabold text-heading text-xl">
                                        {{ tr('references.author') }}
                                    </div>
                                    <div class="text-xl text-text">
                                        {{ author }}
                                    </div>
                                </template>
                            </div>
                        </div>

                        <div class="w-full flex flex-col md:flex-row justify-start items-center"
                             v-if="hasImages">
                            <div class="image-container flex-none w-full md:w-1/3 md:mr-5 my-3"
                                 v-for="image of images"
                            >
                                <img :src="require(`../assets/img/references/${image}`)" alt="" class="w-full">
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div class="w-full h-12 bg-white flex justify-end fixed lg:absolute left-0 top-0 shadow-lg">
                <div @click.stop="close"
                     class="close flex flex-col items-center justify-center cursor-pointer"
                >
                    <div class="line" id="line1"></div>
                    <div class="line" id="line2"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {Translatable} from '@/data/translations';

export default {
    name: 'DetailProject',
    mixins: [Translatable],
    props: {
        data: Object,
    },
    data() {
        return {
            mainImageLoaded: false,
        };
    },
    mounted() {
        let mainImage = new Image();
        mainImage.src = this.mainImage;

        if (mainImage.complete)
            this.setMainImage();
        else
            mainImage.onload = () => this.setMainImage();
    },
    beforeDestroy() {
        this.close();
    },
    computed: {
        title() {
            return this.data.title ?? this.data.thumbnail.title;
        },
        subTitle() {
            return this.data.subTitle ?? this.data.thumbnail.subTitle;
        },

        country() {
            return this.data.country;
        },
        location() {
            return this.data.location;
        },
        completion() {
            return this.data.completion;
        },
        investor() {
            return this.data.investor;
        },
        architect() {
            return typeof this.data.architect === 'string' ?
                [this.data.architect] :
                this.data.architect;
        },
        author() {
            return this.data.author;
        },

        textHeader() {
            return this.data.textHeader;
        },
        text() {
            return this.data.text;
        },

        mainImage() {
            return `/img/public/${this.data.mainImage}`;
        },
        images() {
            return this.data.images;
        },
        hasImages() {
            return !!this.images.length;
        },
    },
    methods: {
        setMainImage() {
            this.$refs['mainImage'].src = this.mainImage;
            this.$nextTick(() => this.mainImageLoaded = true);
        },

        close() {
            this.$emit('close');
        },
        ignore() {
        },
    },
};
</script>

<style scoped>

.image-container:first-child {
    padding-left: 0;
}

.image-container:last-child {
    padding-right: 0;
}

.close {
    width: 30px;
    margin: 0 20px 0 0;
}

.line {
    width: 100%;
    height: 3px;
    background-color: black;
}

#line1 {
    transform: rotate(45deg) translate(3px);
}

#line2 {
    transform: rotate(-45deg) translate(1px);
}

#main_image {
    height: 576px;
}

#content_container {
    position: absolute;
    max-width: 1024px;

    left: 0;
    right: 0;
    top: 2.4rem;
    bottom: 2.4rem;
    margin: auto;
}

@media (max-width: 1440px) {
    #main_image {
        height: 25rem;
    }
}

@media (max-width: 1024px) {
    #content_container {
        width: 100vw;
        height: 100vh;
    }

    #main_image {
        height: 20rem;
    }
}

@media (max-width: 640px) {
    #main_image {
        height: 16.5rem;
    }
}

</style>
